"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ErrorFallBackComponent;
var _react = _interopRequireDefault(require("react"));
var _reactSharedUiNext = require("@eon-funke/react-shared-ui-next");
var _cicUtils = require("@eon-funke/cic-utils");
// NOTE: real err should be logged somewhere
function ErrorFallBackComponent() {
  return /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Alert, {
    type: "error",
    id: "cscn-general-error",
    qaId: "cscn-general-error"
  }, _cicUtils.GlobalErrorHandler.getErrorMessage('serverError'));
}